import {
  submitReview,
  submitReAudit,
  updateMaterialGrading,
} from '@/api/creative/review'

import _ from 'lodash'

export const reviewMixin = {
  data() {
    return {
      formAttrs: {
        labelWidth: '120px',
        labelPosition: 'top',
      },

      saving: false,
    }
  },

  computed: {
    submitButtonAttrs() {
      return {
        type: 'primary',
        loading: this.saving,
      }
    },
  },

  methods: {
    handleSubmitClick() {
      if (this.$refs.form) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit()
          }
        })
        // 批量素材分级
      } else if (this.$refs.materialForm) {
        this.$refs.materialForm.validate((valid) => {
          if (valid) {
            this.updateGrading()
          }
        })
      } else {
        this.submit()
      }
    },

    async submit() {
      this.saving = true
      try {
        const id = this.material ? this.material.id : this.materialIds
        const materialStatus = this.material && this.material.status

        // 普通素材审核参数
        let postData = {
          ...this.cookSubmitParams(),
          ids: String(id),
        }

        // 素材审核数量
        const id_count = postData.ids.split(',').length

        // adv广告主素材审核参数拼接
        if (this.isNeedToCreateDemand) {
          postData = {
            ...postData,
            status: 4,
            am_id: Number(this.pmId || this.model.pm_id),
            adv_id: Number(this.advId || this.model.adv_id),
          }
        }
        // 审核素材状态为通过、拒绝，调用重审接口
        // 审核素材状态为其他，调用审核接口
        const request =
          [2, 3].includes(Number(materialStatus)) ||
          this.tabName === 'Audit Result（审核结果）'
            ? submitReAudit
            : submitReview

        const res = await request(postData)
        const code = _.get(res, 'data.code')

        // 素材进入复审数量
        const review_cnt = _.get(res, 'data.data.review_cnt')

        if (code === 0) {
          if (review_cnt === 0) {
            this.$message({ message: '素材已审核', type: 'info' })
          } else if (id_count === review_cnt) {
            this.$message({ message: '素材进入复审', type: 'info' })
          } else {
            this.$message({
              message: '部分素材审核完成，部分进入复审',
              type: 'info',
            })
          }
          this.hideAuditDialog()
        }
      } catch (error) {
        console.log(error)
      }
      this.saving = false
    },

    async updateGrading() {
      this.saving = true
      try {
        const params = {
          ids: this.materialIds && this.materialIds.split(',').map(Number),
          material_grading: this.materialModel.material_grading.join(),
        }

        const res = await updateMaterialGrading(params)
        const code = _.get(res, 'data.code')
        if (code === 0) {
          this.$message({ message: '操作成功', type: 'success' })
          this.hideAuditDialog()
        }
      } catch (error) {
        console.log(error)
      }
      this.saving = false
    },
  },
}
